export default {"src":"/_next/static/media/drop.b03a0fcf.svg","height":54,"width":55};